import { inject, observer } from 'mobx-react';
import withRouter from '@/components/withRouter';

const MobileInsideHome = () => {
    return <>GRT移动端内部智能体首页</>;
};
export default withRouter(inject('store')(observer(MobileInsideHome)));
